<template>
  <v-dialog v-model="dialog" width="1200px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" text small v-bind="attrs" v-on="on">
        <v-icon left color="primary">mdi-link</v-icon>
        <span class="primary--text">Ontology: Relation 2022</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="text-h5">Ontology: Relation 2022</span>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :items-per-page="1000"
          hide-default-footer
          fixed-header
          height="600"
          :headers="headers"
          :items="relations"
          class="elevation-1"
        ></v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      headers: [
        {
          text: "Category",
          align: "start",
          sortable: false,
          value: "Category",
        },
        { text: "Namespace", value: "Namespace" },
        { text: "Relation", value: "Relation" },
        { text: "Domain", value: "Domain" },
        { text: "Range", value: "Range" },
        { text: "Description", value: "Description" },
      ],
      relations: [
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "hasAdoptedHeir",
          Domain: "Actor",
          Range: "Actor",
          Description: "양자 ~를 두었다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "hasBrother",
          Domain: "Actor",
          Range: "Actor",
          Attribute: "형,동생,오빠",
          Description: "형제 ~가 있다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "hasBrotherInLaw",
          Domain: "Actor",
          Range: "Actor",
          Attribute: "매부, 동서",
          Description: "매부, 동서 ~가 있다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "hasConcubine",
          Domain: "Actor",
          Range: "Actor",
          "Inverse Relation": "hasHusband",
          Description: "첩 ~를 두었다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "hasCousin",
          Domain: "Actor",
          Range: "Actor",
          Description: "~가 사촌이다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "hasDaughter",
          Domain: "Actor",
          Range: "Actor",
          "Inverse Relation": "hasFather",
          Description: "딸 ~가 있다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "hasDaughterInLaw",
          Domain: "Actor",
          Range: "Actor",
          Description: "머느리 ~가 있다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "hasDescendant",
          Domain: "Actor",
          Range: "Actor",
          Description: "후손 ~가 있다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "hasDisciple",
          Domain: "Actor",
          Range: "Actor",
          "Inverse Relation": "hasMaster",
          Description: "제자 ~가 있다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "hasFather",
          Domain: "Actor",
          Range: "Actor",
          "Inverse Relation": "hasSon / hasDaughter",
          Description: "~가 아버지이다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "hasFatherInLaw",
          Domain: "Actor",
          Range: "Actor",
          "Inverse Relation": "hasSonInLaw",
          Description: "~가 장인이다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "hasGrandDaughter",
          Domain: "Actor",
          Range: "Actor",
          Description: "손녀 ~가 있다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "hasGrandson",
          Domain: "Actor",
          Range: "Actor",
          Description: "손자 ~가 있다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "hasHusband",
          Domain: "Actor",
          Range: "Actor",
          "Inverse Relation": "hasWife / hasConcubine",
          Description: "~가 남편이다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "hasMaster",
          Domain: "Actor",
          Range: "Actor",
          "Inverse Relation": "hasDisciple",
          Description: "~가 스승이다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "hasMother",
          Domain: "Actor",
          Range: "Actor",
          "Inverse Relation": "hasSon / hasDaughter",
          Description: "~가 어머니이다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "hasOwner",
          Domain: "Actor",
          Range: "Actor",
          Description: "주인은 ~이다 ※ 노비-주인 관계",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "hasSister",
          Domain: "Actor",
          Range: "Actor",
          Attribute: "누나,언니, 여동생",
          Description: "여자형자 ~가 있다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "hasSisterInLaw",
          Domain: "Actor",
          Range: "Actor",
          Attribute: "시누이, 동서",
          Description: "시누이, 동서 ~가 있다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "hasSon",
          Domain: "Actor",
          Range: "Actor",
          "Inverse Relation": "hasFather / hasMother",
          Description: "아들 ~이 있다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "hasSonInLaw",
          Domain: "Actor",
          Range: "Actor",
          Attribute: "hasFatherInLaw",
          Description: "사위 ~이 있다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "hasSubject",
          Domain: "Actor",
          Range: "Actor",
          Description: "신하 ~이 있다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "hasWife",
          Domain: "Actor",
          Range: "Actor",
          "Inverse Relation": "hasHusband",
          Attribute: "차서",
          Description: "부인 ~이 있다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "isAffinalKinOf",
          Domain: "Actor",
          Range: "Actor",
          Description: "~의 인척이다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "isFellowOf",
          Domain: "Actor",
          Range: "Actor",
          Description: "~의 친구이다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "isLineageKinOf",
          Domain: "Actor",
          Range: "Actor",
          Description: "~의 친척이다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "isMentionedBy",
          Domain: "Actor",
          Range: "Actor",
          Description: "~에 의해 연급되었다",
        },
        {
          Category: "A1",
          Namespace: "foaf:",
          Relation: "knows",
          Domain: "Actor",
          Range: "Actor",
          Description: "~의 지인이다",
        },
        {
          Category: "A1",
          Namespace: "ekc:",
          Relation: "wasOrdainedBy",
          Domain: "Actor",
          Range: "Actor",
          Description: "~로부터 계를 받았다 ※ 승려 간",
        },
        {
          Category: "A2",
          Namespace: "ekc:",
          Relation: "annotator",
          Domain: "Record",
          Range: "Actor",
          Description: "주석가는 ~이다",
        },
        {
          Category: "A2",
          Namespace: "ekc:",
          Relation: "calligrapher",
          Domain: "Record",
          Range: "Actor",
          Description: "(금석문의) 글씨 쓴 이는 ~이다",
        },
        {
          Category: "A2",
          Namespace: "dcterms:",
          Relation: "contributor",
          Domain: "Record/Object/Event",
          Range: "Actor",
          Description: "기여자는 ~이다",
        },
        {
          Category: "A2",
          Namespace: "dcterms:",
          Relation: "creator",
          Domain: "Record/Object",
          Range: "Actor",
          Description: "(문헌/작품의) 창작자는 ~이다",
        },
        {
          Category: "A2",
          Namespace: "ekc:",
          Relation: "creatorPresumed",
          Domain: "Record/Object",
          Range: "Actor",
          Description: "(문헌/작품의) 작가는 ~라고 알려져 있다",
        },
        {
          Category: "A2",
          Namespace: "ekc:",
          Relation: "editor",
          Domain: "Record",
          Range: "Actor",
          Description: "편집자는 ~이다",
        },
        {
          Category: "A2",
          Namespace: "ekc:",
          Relation: "doner",
          Domain: "Record/Object",
          Range: "Actor",
          Description: "(유물의) 기증자는 ~이다",
        },
        {
          Category: "A2",
          Namespace: "ekc:",
          Relation: "inscriber",
          Domain: "Record",
          Range: "Actor",
          Description: "(금석문의) 글씨를 새긴 이는 ~이다",
        },
        {
          Category: "A2",
          Namespace: "dcterms:",
          Relation: "publisher",
          Domain: "Record",
          Range: "Actor",
          Description: "출판자는 ~이다",
        },
        {
          Category: "A2",
          Namespace: "ekc:",
          Relation: "owner",
          Domain: "Record/Object",
          Range: "Actor",
          Description: "(유물의) 소유주는 ~이다",
        },
        {
          Category: "A2",
          Namespace: "dcterms:",
          Relation: "rightsHolder",
          Domain: "Record/Object",
          Range: "Actor",
          Description: "저작권자는 ~이다 ※ 저작권 보유자",
        },
        {
          Category: "A2",
          Namespace: "ekc:",
          Relation: "translator",
          Domain: "Record",
          Range: "Actor",
          Description: "번역자는 ~이다",
        },
        {
          Category: "A2",
          Namespace: "ekc:",
          Relation: "writer",
          Domain: "Record",
          Range: "Actor",
          Description: "(금석문의) 글 쓴 이는 ~이다",
        },
        {
          Category: "A3",
          Namespace: "ekc:",
          Relation: "hasAffiliation",
          Domain: "Actor",
          Range: "Agent",
          Description: "~에 소속하다",
        },
        {
          Category: "A3",
          Namespace: "ekc:",
          Relation: "isMemberOf",
          Domain: "Actor",
          Range: "Agent",
          "Inverse Relation": "member",
          Description: "~의 일원이다",
        },
        {
          Category: "A3",
          Namespace: "foaf:",
          Relation: "member",
          Domain: "Agent",
          Range: "Actor",
          "Inverse Relation": "isMemberOf",
          Description: "구성원 ~이 있다",
        },
        {
          Category: "A4",
          Namespace: "ekc:",
          Relation: "servesAs",
          Domain: "Actor",
          Range: "Concept",
          Description: "관직 ~를 역임했다",
        },
        {
          Category: "A4",
          Namespace: "ekc:",
          Relation: "servesTemporallyAs",
          Domain: "Actor",
          Range: "Concept",
          Description: "임시로 ~의 직책을 수행해다",
        },
        {
          Category: "A4",
          Namespace: "ekc:",
          Relation: "wasPosthumouslyPromotedTo",
          Domain: "Actor",
          Range: "Concept",
          Description: "증직 ~를 받다",
        },
        {
          Category: "A4",
          Namespace: "ekc:",
          Relation: "isOfficialPostOf",
          Domain: "Concept",
          Range: "Agent",
          Description: "관청 ~의 관직이다",
        },
        {
          Category: "A4",
          Namespace: "ekc:",
          Relation: "hasAppointee",
          Domain: "Record",
          Range: "Actor",
          Description: "(임명장에 기록된) 피임자는 ~이다",
        },
        {
          Category: "P1",
          Namespace: "ekc:",
          Relation: "enshrines",
          Domain: "Place",
          Range: "Actor",
          Description: "~를 제향하다",
        },
        {
          Category: "P1",
          Namespace: "ekc:",
          Relation: "isBirthPlaceOf",
          Domain: "Place",
          Range: "Actor",
          Description: "~의 생가/출생지이다",
        },
        {
          Category: "P1",
          Namespace: "ekc:",
          Relation: "isDeliveryPlaceOf",
          Domain: "Place",
          Range: "Actor",
          Description: "~의 수태지이다",
        },
        {
          Category: "P1",
          Namespace: "ekc:",
          Relation: "isNear",
          Domain: "Place",
          Range: "Place",
          Description: "~에 가까이 있다",
        },
        {
          Category: "P1",
          Namespace: "ekc:",
          Relation: "isPlacentaChamberOf",
          Domain: "Place",
          Range: "Actor",
          Description: "~의 태실이다",
        },
        {
          Category: "P1",
          Namespace: "ekc:",
          Relation: "isSiteOf",
          Domain: "Place",
          Range: "Place/Architecture/Agent",
          Description: "~의 유적지이다",
        },
        {
          Category: "P2",
          Namespace: "ekc:",
          Relation: "isEnshrinedIn",
          Domain: "Actor",
          Range: "Place",
          Description: "~에 제향되다",
        },
        {
          Category: "P2",
          Namespace: "ekc:",
          Relation: "livesIn",
          Domain: "Actor",
          Range: "Place",
          Description: "~에 살다",
        },
        {
          Category: "P2",
          Namespace: "ekc:",
          Relation: "wasBuriedIn",
          Domain: "Actor",
          Range: "Place",
          Description: "~에 뭍혔다",
        },
        {
          Category: "P2",
          Namespace: "ekc:",
          Relation: "wasExecutedAt",
          Domain: "Actor",
          Range: "Place",
          Description: "~에서 처형되었다",
        },
        {
          Category: "P2",
          Namespace: "edm:",
          Relation: "currentLocation",
          Domain: "Object",
          Range: "Place/Agent",
          Description: "소재지(소장처)는 ~이다",
        },
        {
          Category: "P2",
          Namespace: "edm:",
          Relation: "formerLocation",
          Domain: "Object",
          Range: "Place/Agent",
          Description: "옛 소재지(소장처)는 ~이다",
        },
        {
          Category: "P2",
          Namespace: "ekc:",
          Relation: "isProducedIn",
          Domain: "Object",
          Range: "Place",
          Description: "~ 지역에서 생산된다",
        },
        {
          Category: "P2",
          Namespace: "ekc:",
          Relation: "isCurrentlySituatedOn",
          Domain: "Place/Architecture/Agent",
          Range: "Place",
          Description: "(현존건물이) 유적지 ~에 있다",
        },
        {
          Category: "P2",
          Namespace: "ekc:",
          Relation: "isLocatedIn",
          Domain: "Place/Architecture/Agent/Object",
          Range: "Place",
          Description: "~에 위치하다",
        },
        {
          Category: "P2",
          Namespace: "ekc:",
          Relation: "isPreviouslySituatedOn",
          Domain: "Place/Architecture/Agent",
          Range: "Place",
          Description: "(부존건물이) 유적지 ~에 있었다",
        },
        {
          Category: "E1",
          Namespace: "edm:",
          Relation: "happenedAt",
          Domain: "Event",
          Range: "Place",
          Description: "(사건이) 장소 ~에서 일어나다",
        },
        {
          Category: "E1",
          Namespace: "ekc:",
          Relation: "isCausedBy",
          Domain: "Event",
          Range: "Event",
          Description: "(사건이) 사건 ~로 인해 발행했다",
        },
        {
          Category: "E1",
          Namespace: "ekc:",
          Relation: "isVictimOf",
          Domain: "Actor",
          Range: "Event",
          Description: "(인물이) 사건 ~의 희생자이다",
        },
        {
          Category: "E1",
          Namespace: "ekc:",
          Relation: "leads",
          Domain: "Actor",
          Range: "Event",
          Description: "(인물이) 사건 ~을 주도하다",
        },
        {
          Category: "E2",
          Namespace: "ekc:",
          Relation: "administrates",
          Domain: "Actor",
          Range: "Event",
          Description: "~를 주관하다",
        },
        {
          Category: "E2",
          Namespace: "ekc:",
          Relation: "hasParticipant",
          Domain: "Event",
          Range: "Actor",
          "Inverse Relation": "participatesIn",
          Description: "참석자 ~가 있다",
        },
        {
          Category: "E2",
          Namespace: "ekc:",
          Relation: "isHeldAt",
          Domain: "Event",
          Range: "Place",
          Description: "~에서 개최되었다",
        },
        {
          Category: "E2",
          Namespace: "ekc:",
          Relation: "isOperatedIn",
          Domain: "Agent",
          Range: "Event",
          Description: "(시설이) 이벤트 ~에서 운영되었다",
        },
        {
          Category: "E2",
          Namespace: "ekc:",
          Relation: "participatesIn",
          Domain: "Actor",
          Range: "Event",
          "Inverse Relation": "hasParticipant",
          Description: "~에 참여하다",
        },
        {
          Category: "E3",
          Namespace: "ekc:",
          Relation: "appearsIn",
          Domain: "Actor",
          Range: "Concept",
          Description: "작품, 공연 ~에 출연하다",
        },
        {
          Category: "E3",
          Namespace: "ekc:",
          Relation: "hasPerformance",
          Domain: "Event",
          Range: "Concept",
          "Inverse Relation": "isPerformedIn",
          Description: "(이벤트에) 공연 ~이 있다",
        },
        {
          Category: "E3",
          Namespace: "ekc:",
          Relation: "isAwarded",
          Domain: "Actor",
          Range: "Object",
          Attribute: "수량 ex) 1필",
          Description: "~을 상으로 받다",
        },
        {
          Category: "E3",
          Namespace: "ekc:",
          Relation: "isPerformedAt",
          Domain: "Event/Concept",
          Range: "Place",
          Description: "(공연/의식이) ~에서 열렸다",
        },
        {
          Category: "E3",
          Namespace: "ekc:",
          Relation: "isPerformedBy",
          Domain: "Concept",
          Range: "Actor",
          Description: "~가 공연했다",
        },
        {
          Category: "E3",
          Namespace: "ekc:",
          Relation: "isPerformedIn",
          Domain: "Concept",
          Range: "Event",
          "Inverse Relation": "hasPerformance",
          Description: "(공연이) 이벤트 ~에서 공연되었다",
        },
        {
          Category: "E3",
          Namespace: "ekc:",
          Relation: "plays",
          Domain: "Actor",
          Range: "Object",
          Description: "악기 ~를 연주하다",
        },
        {
          Category: "E4",
          Namespace: "ekc:",
          Relation: "curates",
          Domain: "Event",
          Range: "Object/Record/Event",
          Description: "~를 전시(큐레이션)하다",
        },
        {
          Category: "E4",
          Namespace: "ekc:",
          Relation: "hasExhibition",
          Domain: "Object/Record",
          Range: "Event",
          Description: "전시회 ~에서 전시되다",
        },
        {
          Category: "E4",
          Namespace: "ekc:",
          Relation: "hasExhibitionAt",
          Domain: "Object/Record",
          Range: "Place/Agent",
          Description: "~에서 전시하다 ※ 소장처 외의 장소. 대여 전시 등.",
        },
        {
          Category: "AR",
          Namespace: "ekc:",
          Relation: "constructor",
          Domain: "Architecture",
          Range: "Actor",
          Description: "건축가는 ~이다",
        },
        {
          Category: "AR",
          Namespace: "ekc:",
          Relation: "hasDrawing",
          Domain: "Architecture",
          Range: "Record",
          Description: "도면 ~이 있다",
        },
        {
          Category: "AR",
          Namespace: "ekc:",
          Relation: "isNamedBy",
          Domain: "Architecture",
          Range: "Actor",
          Description: "~가 명명했다",
        },
        {
          Category: "AR",
          Namespace: "ekc:",
          Relation: "reconstructor",
          Domain: "Architecture",
          Range: "Actor",
          Description: "재건자는 ~이다 ※ 수축(修築)을 지휘",
        },
        {
          Category: "AR",
          Namespace: "ekc:",
          Relation: "renovator",
          Domain: "Architecture",
          Range: "Actor",
          Description: "중건자는 ~이다 ※ 중창·중건 추진",
        },
        {
          Category: "AR",
          Namespace: "ekc:",
          Relation: "founder",
          Domain: "Architecture/Agent",
          Range: "Actor",
          Description: "설립자는 ~이다",
        },
        {
          Category: "CL",
          Namespace: "ekc:",
          Relation: "wears",
          Domain: "Actor",
          Range: "Clothing",
          Description: "복장 ~를 입다",
        },
        {
          Category: "CL",
          Namespace: "ekc:",
          Relation: "isWornIn",
          Domain: "Clothing",
          Range: "Event/Concept",
          Description: "(복장을) 행사 ~에서 입다",
        },
        {
          Category: "FO",
          Namespace: "ekc:",
          Relation: "serves",
          Domain: "Actor",
          Range: "Food",
          Description: "음식 ~을 차린다",
        },
        {
          Category: "FO",
          Namespace: "ekc:",
          Relation: "cooks",
          Domain: "Agent",
          Range: "Food",
          Description: "음식 ~을 조리한다",
        },
        {
          Category: "FO",
          Namespace: "ekc:",
          Relation: "prepares",
          Domain: "Agent",
          Range: "Food",
          Description: "음식, 식재료 ~을 준비한다",
        },
        {
          Category: "FO",
          Namespace: "ekc:",
          Relation: "hasIngredient",
          Domain: "Food",
          Range: "Food",
          Description: "식재료 ~를 쓴다",
        },
        {
          Category: "FO",
          Namespace: "ekc:",
          Relation: "isGarnishedWith",
          Domain: "Food",
          Range: "Object",
          Description: "상화 ~로 장식하다",
        },
        {
          Category: "FO",
          Namespace: "ekc:",
          Relation: "isProvidedIn",
          Domain: "Food",
          Range: "Event",
          Description: "(상차림이) 이벤트 ~에서 제공되다",
        },
        {
          Category: "FO",
          Namespace: "ekc:",
          Relation: "isServedIn",
          Domain: "Food",
          Range: "Object",
          Description: "(음식이) 그릇 ~에 담아 제공되다",
        },
        {
          Category: "FO",
          Namespace: "ekc:",
          Relation: "isServedOn",
          Domain: "Food",
          Range: "Object",
          Description: "(음식이) 음식상 ~에 차려지다(음식)",
        },
        {
          Category: "FO",
          Namespace: "ekc:",
          Relation: "isServedTo",
          Domain: "Food",
          Range: "Actor",
          Description: "인물 ~에게 제공되다",
        },
        {
          Category: "OB",
          Namespace: "ekc:",
          Relation: "commemorates",
          Domain: "Object/Event/Record",
          Range: "Event",
          Description: "~를 기념하다",
        },
        {
          Category: "OB",
          Namespace: "ekc:",
          Relation: "goesWith",
          Domain: "Object",
          Range: "Object",
          Description: "~를 수반하다",
        },
        {
          Category: "OB",
          Namespace: "ekc:",
          Relation: "hasInscription",
          Domain: "Object",
          Range: "Text",
          Description: "(물품에) 명문 ~가 새겨져 있다",
        },
        {
          Category: "OB",
          Namespace: "ekc:",
          Relation: "isMadeOf",
          Domain: "Object",
          Range: "Object",
          Description: "~로 만들었다",
        },
        {
          Category: "OB",
          Namespace: "ekc:",
          Relation: "isStoredIn",
          Domain: "Object",
          Range: "Place/Architecture",
          Description: "~에 보관하다",
        },
        {
          Category: "OB",
          Namespace: "ekc:",
          Relation: "isUsedIn",
          Domain: "Object",
          Range: "Event",
          Description: "~에 쓰인다",
        },
        {
          Category: "RE",
          Namespace: "ekc:",
          Relation: "isDepictedIn",
          Domain: "Any",
          Range: "Record",
          "Inverse Relation": "depicts",
          Description: "~에 묘사되어 있다",
        },
        {
          Category: "RE",
          Namespace: "ekc:",
          Relation: "isMentionedIn",
          Domain: "Any",
          Range: "Record",
          "Inverse Relation": "mentions",
          Description: "~에 언급되다",
        },
        {
          Category: "RE",
          Namespace: "ekc:",
          Relation: "depicts",
          Domain: "Object/Record",
          Range: "Any",
          "Inverse Relation": "isDepictedIn",
          Description: "~를 묘사하다",
        },
        {
          Category: "RE",
          Namespace: "ekc:",
          Relation: "documents",
          Domain: "Record",
          Range: "Event",
          Description: "~를 문서화하다",
        },
        {
          Category: "RE",
          Namespace: "ekc:",
          Relation: "hasEpitaph",
          Domain: "Record",
          Range: "Text",
          Description: "(비석에) 비문 ~가 새겨져 있다",
        },
        {
          Category: "RE",
          Namespace: "ekc:",
          Relation: "hasHistoricalSetting",
          Domain: "Record",
          Range: "Event",
          Description: "(작품의) 역사적 배경은 ~이다",
        },
        {
          Category: "RE",
          Namespace: "ekc:",
          Relation: "hasText",
          Domain: "Record",
          Range: "Text",
          Description: "문장 ~이 있다",
        },
        {
          Category: "RE",
          Namespace: "ekc:",
          Relation: "hasVersion",
          Domain: "Record",
          Range: "Record",
          Description: "판본 ~이 있다",
        },
        {
          Category: "RE",
          Namespace: "ekc:",
          Relation: "isPostedIn",
          Domain: "Record",
          Range: "Record",
          Description: "사진이 문헌(신문, 잡지) ~에 실렸다",
        },
        {
          Category: "RE",
          Namespace: "ekc:",
          Relation: "mentions",
          Domain: "Record",
          Range: "Any",
          "Inverse Relation": "isMentionedIn",
          Description: "~를 언급하다",
        },
        {
          Category: "RE",
          Namespace: "ekc:",
          Relation: "references",
          Domain: "Record/Concept",
          Range: "Record",
          Description: "~를 참고하다",
        },
        {
          Category: "RE",
          Namespace: "edm:",
          Relation: "isDerivativeOf",
          Domain: "Record/Object",
          Range: "Record/Object",
          Description: "~의 파생물이다",
        },
        {
          Category: "RE",
          Namespace: "edm:",
          Relation: "isSuccessorOf",
          Domain: "Record/Object",
          Range: "Record/Object",
          Description: "~의 후속이다 ※ 속편 작품",
        },
        {
          Category: "RE",
          Namespace: "dcterms:",
          Relation: "provenance",
          Domain: "Record/Object",
          Range: "Place/Agent",
          Description: "출처는 ~이다 ※ 출처; 원 소장처; 발견·발굴 장소",
        },
        {
          Category: "HR",
          Namespace: "ekc:",
          Relation: "hasAsset",
          Domain: "Place",
          Range: "Architecture/Object/Record",
          Description: "(상위 문화재가) 개별 문화재 ~을 가지고 있다",
        },
        {
          Category: "HR",
          Namespace: "ekc:",
          Relation: "hasBranchTemple",
          Domain: "Place",
          Range: "Place",
          Description: "(사찰 본사에) 말사 ~가 있다",
        },
        {
          Category: "HR",
          Namespace: "ekc:",
          Relation: "hasHermitage",
          Domain: "Place",
          Range: "Place",
          Description: "(사찰에) 암자 ~가 있다",
        },
        {
          Category: "HR",
          Namespace: "ekc:",
          Relation: "isDesignatedAs",
          Domain: "Place",
          Range: "Heritage",
          Description: "(문화재) ~로 지정되다",
        },
        {
          Category: "HR",
          Namespace: "ekc:",
          Relation: "isSteleOf",
          Domain: "Object",
          Range: "Actor",
          Description: "~의 신도비(탑비)이다",
        },
        {
          Category: "HR",
          Namespace: "ekc:",
          Relation: "isTombstoneOf",
          Domain: "Object",
          Range: "Actor",
          Description: "~의 비석이다",
        },
        {
          Category: "HR",
          Namespace: "ekc:",
          Relation: "isStupaOf",
          Domain: "Object",
          Range: "Actor",
          Description: "~의 승탑이다",
        },
        {
          Category: "HR",
          Namespace: "ekc:",
          Relation: "isTombOf",
          Domain: "Place",
          Range: "Actor",
          Description: "~의 무덤이다",
        },
        {
          Category: "NM",
          Namespace: "ekc:",
          Relation: "hasNewName",
          Domain: "Place/Architecture/Agent",
          Range: "Place/Architecture/Agent",
          "Inverse Relation": "hasOldName",
          Description: "새 이름은 ~이다 ※ 새 명칭; 후신(後身)",
        },
        {
          Category: "NM",
          Namespace: "ekc:",
          Relation: "hasOldName",
          Domain: "Place/Architecture/Agent",
          Range: "Place/Architecture/Agent",
          "Inverse Relation": "hasNewName",
          Description: "옛 이름은 ~이다 ※ 구 명칭; 전신(前身)",
        },
        {
          Category: "NM",
          Namespace: "ekc:",
          Relation: "isNamedAfter",
          Domain: "Place/Architecture/Agent",
          Range: "Place/Architecture/Agent",
          Description: "~를 따라 이름지었다",
        },
        {
          Category: "NM",
          Namespace: "ekc:",
          Relation: "isNamesakeOf",
          Domain: "Place/Architecture/Agent",
          Range: "Place/Architecture/Agent",
          Description: "~와 같은 이름이다 ※ 실체는 다른데 이름이 같은 경우",
        },
        {
          Category: "CO",
          Namespace: "dcterms:",
          Relation: "hasPart",
          Domain: "Any",
          Range: "Any",
          "Inverse Relation": "isPartOf",
          Attribute: "수량 ex) 5개",
          Description: "부분 ~이 있다",
        },
        {
          Category: "CO",
          Namespace: "ekc:",
          Relation: "isInfluencedBy",
          Domain: "Any",
          Range: "Any",
          Description: "~에 의해 영향받다",
        },
        {
          Category: "CO",
          Namespace: "ekc:",
          Relation: "isKindOf",
          Domain: "Any",
          Range: "Any",
          Description: "~의 한 종류이다 ※ 분류 체계상의 분류인 경우에는 type",
        },
        {
          Category: "CO",
          Namespace: "dcterms:",
          Relation: "isPartOf",
          Domain: "Any",
          Range: "Any",
          "Inverse Relation": "hasPart",
          Description: "~의 부분이다",
        },
        {
          Category: "CO",
          Namespace: "edm:",
          Relation: "isRelatedTo",
          Domain: "Any",
          Range: "Any",
          Description: "~와 관계가 있다",
        },
        {
          Category: "CO",
          Namespace: "ekc:",
          Relation: "mightBeRelatedTo",
          Domain: "Any",
          Range: "Any",
          Description: "~과 관계가 있을 지도 모른다",
        },
        {
          Category: "CO",
          Namespace: "owl:",
          Relation: "sameAs",
          Domain: "Any",
          Range: "Any",
          Description: "~와 같다",
        },
        {
          Category: "CO",
          Namespace: "dcterms:",
          Relation: "type",
          Domain: "Any",
          Range: "Any",
          Description: "유형은 ~이다",
        },
        {
          Category: "CO",
          Namespace: "ekc:",
          Relation: "includes",
          Domain: "Concept",
          Range: "Any",
          Description: "~를 포함하다",
        },
        {
          Category: "CO",
          Namespace: "edm:",
          Relation: "isNextInSequenceTo",
          Domain: "Event/Concept",
          Range: "Event/Concept",
          "Inverse Relation": "isPreviousInSequenceTo",
          Description:
            "(순서상) ~ 다음이다 ※ 사건, 항목 간의 인접연속 관계. B 다음이 A인 순서.",
        },
        {
          Category: "CO",
          Namespace: "ekc:",
          Relation: "isPreviousInSequenceTo",
          Domain: "Event/Concept",
          Range: "Event/Concept",
          "Inverse Relation": "isNextInSequenceTo",
          Description:
            "(순서상) ~ 앞이다. ※ 사건, 항목 간의 인접연속 관계. A 다음이 B인 순서.",
        },
        {
          Category: "XR",
          Namespace: "ekc:",
          Relation: "bibliography",
          Domain: "Any",
          Range: "Index",
          Description:
            "참고문헌 목록은 ~이다 ※ 목적어는 참고문헌 색인(bib-XXXX) 노드",
        },
        {
          Category: "XR",
          Namespace: "ekc:",
          Relation: "onlineReference",
          Domain: "Any",
          Range: "Index",
          Description:
            "웹자원 목록은 ~이다 ※ 목적어는 웹자원 색인(ref-XXXX) 노드",
        },
        {
          Category: "XR",
          Namespace: "ekc:",
          Relation: "textReference",
          Domain: "Any",
          Range: "Text",
          Description:
            "문헌상의 근거 텍스트는 ~이다 ※ 목적어는 온라인 텍스트 원문",
        },
        {
          Category: "XR",
          Namespace: "ekc:",
          Relation: "isShownAt",
          Domain: "Any/Index",
          Range: "WebResource",
          Attribute: "해설, 참고, 원문",
          Description: "웹 자원 ~에 보인다",
        },
        {
          Category: "XR",
          Namespace: "ekc:",
          Relation: "isShownBy",
          Domain: "Any/Index",
          Range: "WebResource/Multimedia",
          Attribute: "3D_지도, 3D_모델, 그림, 도면, 동영상, 사진",
          Description: "웹 자원 ~에 보인다",
        },
        {
          Category: "XR",
          Namespace: "ekc:",
          Relation: "isReferencedFrom",
          Domain: "Index",
          Range: "Bibliography",
          Description: "문헌자료 ~를 참고하다",
        },
        {
          Category: "XR",
          Namespace: "ekc:",
          Relation: "hasReferenceNote",
          Domain: "Multimedia",
          Range: "Any",
          Description:
            "고증기록 ~이 있다 ※ 목적어는 3D 재현물에 관한 고증 사실을 기록한 온라인 기사",
        },
        {
          Category: "XR",
          Namespace: "ekc:",
          Relation: "hasChineseExplanation",
          Domain: "Story",
          Range: "Story",
          Description: "중국어 해설문 ~이 있다",
        },
        {
          Category: "XR",
          Namespace: "ekc:",
          Relation: "hasEnglishExplanation",
          Domain: "Story",
          Range: "Story",
          Description: "영어 해설문 ~이 있다",
        },
      ],
    };
  },
};
</script>

<style></style>
